export default {
    state: {
        topTabs: {
            'age': {name: '연령별', subName: '', code: 'age'},
            'vulnerable': {name: '취약계층', subName: '', code: 'vulnerable'},
            'local': {name: '생활인구', subName: '(내국인)', code: 'local'},
            'foreigner': {name: '생활인구', subName: '(외국인)', code: 'foreigner'},
        },
        midTabs: {
            'age': {
                'totalPop': {
                    name: '총인구', subName: '', code: 'totalPop', hjdCodeCol: 'val1',
                    popCols: ['val2', 'val3'],
                    colorScale: d3.scaleLinear().domain([10000, 60000]).range(["#1bd5fc", "#2e4dd7"]).clamp(true),
                },
                'youngManPop': {
                    name: '유소년(0 ~ 14세)', subName: '', code: 'youngManPop', hjdCodeCol: 'val1',
                    popCols: ['val4', 'val5', 'val6', 'val7', 'val8', 'val9'],
                    colorScale: d3.scaleLinear().domain([1000, 10000]).range(["#1bd5fc", "#2e4dd7"]).clamp(true),
                },
                'adultManPop': {
                    name: '청장년(15 ~ 64세)', subName: '', code: 'adultManPop', hjdCodeCol: 'val1',
                    popCols: [
                        'val10', 'val11', 'val12', 'val13', 'val14',
                        'val15', 'val16', 'val17', 'val18', 'val19',
                        'val20', 'val21', 'val22', 'val23', 'val24',
                        'val25', 'val26', 'val27', 'val28', 'val29'
                    ],
                    colorScale: d3.scaleLinear().domain([7000, 39000]).range(["#1bd5fc", "#2e4dd7"]).clamp(true),
                },
                'oldManPop': {
                    name: '노령(65세 이상)', subName: '', code: 'oldManPop', hjdCodeCol: 'val1',
                    popCols: ['val46', 'val47'],
                    colorScale: d3.scaleLinear().domain([2000, 8000]).range(["#1bd5fc", "#2e4dd7"]).clamp(true),
                },
            },
            'vulnerable': {
                'disabledPersonPop': {
                    name: '장애인', subName: '', code: 'disabledPersonPop', hjdCodeCol: 'val34',
                    colorScale: d3.scaleLinear().domain([500, 2500]).range(["#f5f33f", "#fb2a29"]).clamp(true),
                    popCols: ['val2', 'val3'],
                },
                'pensionerPop': {
                    name: '기초생활수급자', subName: '', code: 'pensionerPop', hjdCodeCol: 'val14',
                    colorScale: d3.scaleLinear().domain([500, 2000]).range(["#f5f33f", "#fb2a29"]).clamp(true),
                    popCols: ['val3'],
                },
            },
            'local' : {
                'totalLocalPop': {
                    name: '총내국인', subName: '', code: 'totalLocalPop', hjdCodeCol: 'val1',
                    popCols: ['val4'],
                    colorScale: d3.scaleLinear().domain([10000, 65000]).range(["#b7d85e", "#0d845b"]).clamp(true),
                },
                '0to9LocalPop': {
                    name: '0 ~ 9세', subName: '', code: '0to9LocalPop', hjdCodeCol: 'val1',
                    popCols: ['val5', 'val21'],
                    colorScale: d3.scaleLinear().domain([500, 6500]).range(["#b7d85e", "#0d845b"]).clamp(true),
                },
                '10to19LocalPop': {
                    name: '10 ~ 19세', subName: '', code: '10to19LocalPop', hjdCodeCol: 'val1',
                    popCols: ['val6', 'val7', 'val22', 'val23'],
                    colorScale: d3.scaleLinear().domain([1000, 8500]).range(["#b7d85e", "#0d845b"]).clamp(true),
                },
                '20to39LocalPop': {
                    name: '20 ~ 39세', subName: '', code: '20to39LocalPop', hjdCodeCol: 'val1',
                    popCols: ['val8', 'val9', 'val10', 'val11', 'val24', 'val25', 'val26', 'val27'],
                    colorScale: d3.scaleLinear().domain([3000, 18000]).range(["#b7d85e", "#0d845b"]).clamp(true),
                },
                '40to59LocalPop': {
                    name: '40 ~ 59세', subName: '', code: '40to59LocalPop', hjdCodeCol: 'val1',
                    popCols: ['val12', 'val13', 'val14', 'val15', 'val28', 'val29', 'val30', 'val31'],
                    colorScale: d3.scaleLinear().domain([2000, 22000]).range(["#b7d85e", "#0d845b"]).clamp(true),
                },
                '60to79LocalPop': {
                    name: '60 ~ 79세', subName: '', code: '60to79LocalPop', hjdCodeCol: 'val1',
                    popCols: ['val16', 'val17', 'val18', 'val19', 'val32', 'val33', 'val34', 'val35'],
                    colorScale: d3.scaleLinear().domain([2000, 12000]).range(["#b7d85e", "#0d845b"]).clamp(true),
                },
                '80overLocalPop': {
                    name: '80세 이상', subName: '', code: '80overLocalPop', hjdCodeCol: 'val1',
                    popCols: ['val20', 'val36'],
                    colorScale: d3.scaleLinear().domain([300, 2300]).range(["#b7d85e", "#0d845b"]).clamp(true),
                },
            },
            'foreigner': {
                'totalForeignerPop': {
                    name: '총외국인', subName: '', code: 'totalForeignerPop', hjdCodeCol: 'hjdCode',
                    popCols: ['popCnt'],
                    colorScale: d3.scaleLinear().domain([100, 800]).range(["#ef82a3", "#634fae"]).clamp(true),
                },
                'stopoverPop': {
                    name: '단기체류', subName: '', code: 'stopoverPop', hjdCodeCol: 'val1',
                    popCols: ['val4'],
                    colorScale: d3.scaleLinear().domain([0, 100]).range(["#ef82a3", "#634fae"]).clamp(true),
                },
                'longStayPop': {
                    name: '장기체류', subName: '', code: 'longStayPop', hjdCodeCol: 'val1',
                    popCols: ['val4'],
                    colorScale: d3.scaleLinear().domain([100, 700]).range(["#ef82a3", "#634fae"]).clamp(true),
                },
            }
        },
        selectedTopTab: {},
        selectedMidTab: {},
    },
    getters: {
        getTopTabs(state) {
            return state.topTabs;
        },
        getMidTabs(state) {
            return state.midTabs;
        },
        getSelectedTopTab(state) {
            return state.selectedTopTab;
        },
        getSelectedMidTab(state) {
            return state.selectedMidTab;
        },
    },
    mutations: {
        SELECTED_TOP_TAB(state, selectedTopTab) {
            state.selectedTopTab = selectedTopTab;
        },
        SELECTED_MID_TAB(state, selectedMidTab) {
            state.selectedMidTab = selectedMidTab;
        },
    },
    actions: {
        SET_SELECTED_TOP_TAB({commit}, selectedTopTab) {
            commit('SELECTED_TOP_TAB', selectedTopTab);
        },
        SET_SELECTED_MID_TAB({commit}, selectedMidTab) {
            commit('SELECTED_MID_TAB', selectedMidTab);
        },
    }
}
